import { useTranslation } from "react-i18next";

import { ChildOverviewProps } from "./types";
import {
  AddressDisplay,
  SectionHeader,
} from "../../../../../components/FormControls";

export const ChildStaySection = ({
  childDetails,
  fetchedData,
  canApply,
}: ChildOverviewProps) => {
  const { t } = useTranslation();
  const current = childDetails.residence?.temporaryAddress;
  const fetched = fetchedData?.residence?.temporaryAddress;

  return (
    <>
      <SectionHeader
        title={t("person.temporaryResidenceInformation")}
        subtitle={t("person.mupSource")}
      />
      <AddressDisplay
        address={current}
        fetchedAddress={fetched}
        canApply={canApply}
        title={t("person.temporaryResidenceInformation")}
      />
    </>
  );
};
